import { HttpStatusCode } from '@app/api/http/constants/http-status-code';
import { useSnackbar } from '@app/contexts/snackbar';
import { LoginContacts, LoginStep, SendTo } from '@app/pages/auth/Login/Login';
import { getErrorMessage } from '@app/utils/http/getErrorMessage';
import { authService } from '@app/utils/services/authService';
import { AxiosError } from 'axios';
import { Dispatch, SetStateAction } from 'react';
import { useMutation } from 'react-query';

export const useStep2 = (
  method: SendTo,
  setSendTo: Dispatch<SetStateAction<SendTo>>,
  email: string,
  phone: string,
  setStep: Dispatch<SetStateAction<LoginStep>>,
  setContacts: Dispatch<SetStateAction<LoginContacts>>
) => {
  const { open, close } = useSnackbar();
  const { mutate, isLoading } = useMutation(authService.sendVerificationCode, {
    onSuccess: () => {
      setStep(3);
    },
    onError: (error: AxiosError) => {
      open({ severity: 'error', message: getErrorMessage(error) });
      if (error?.response?.status === HttpStatusCode.TooManyRequests) {
        setContacts({ email, phone: null });
        setSendTo('email');
        setStep(2);
      }
    },
  });
  const send = () => {
    close();
    mutate({ method, email, phone });
  };

  return {
    isLoading,
    send,
  };
};
